module.exports = __webpack_public_path__ + "img/toast-error.29837a52.svg";